export default __webpack_public_path__ + "../staticImages/sprite-giftvoucher-2x.png";